import { ArrowPathIcon, TrashIcon } from "@heroicons/react/24/solid";
import { useApplicationModals } from "app/common/hooks";
import { useBarcodeScanner } from "app/context/BarcodeScannerContext";
import { resolveProductBarcode } from "app/common/resolveProductBarcode";
import {
  Button,
  DottedOutlineButton,
  IconButton,
} from "app/components/atoms/button";
import { InputLabel } from "app/components/atoms/form";
import { FormHeader, FormSummary } from "app/components/atoms/layout";
import Table from "app/components/atoms/table";
import Typography from "app/components/atoms/typography";
import { InputMolecule } from "app/components/molecules/form";
import ImageWithPreview from "app/components/molecules/imageWithPreview";
import {
  ProductSelectSearchMolecule,
  SelectMolecule,
} from "app/components/molecules/select";
import api from "app/integration/api";
import { useFetcher, useUpdateForm, useCollector } from "app/integration/common/hooks";
import MainLayout from "app/layouts/main";
import AppModals from "app/modals";
import clsx from "clsx";
import { FieldArray, Formik, getIn } from "formik";
import { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import style from "style/height.module.css";
import * as Yup from "yup";
import { isEmpty } from "underscore";
import { useToast } from "app/components/atoms/toast/toast";
import { MinusCircleIcon, PlusIcon } from "@heroicons/react/24/outline";
const breadcrumbItems = [
  { label: "Sales", href: "/sales_order" },
  { label: "Order", href: "/sales_order" },
  { label: "Ubah Order", href: "#" },
];

function UpdateSalesOrderPage() {
  let { id } = useParams();
  const navigate = useNavigate();
  let isError = false;
  const { showToast } = useToast();

  const [productsAll, setProductsAll] = useState([]);
  const [addresses, setAddress] = useState([]);
  const [delivery_fee, setDeliveryFee] = useState(0);
  const [selectedCourier, setSelectedCourier] = useState("");
  const [needUpdateDeliveryFee, setNeedUpdateDeliveryFee] = useState(false);
  const [salesChannels] =
    useCollector({ modelName: "salesChannel" });
  const [productVariants] =
    useCollector({ modelName: "productVariant" });
  const formSalesOrder = useRef(null);

  const handleSuccess = () => {
    navigate("/sales_order");
  };

  const checkNew = (
    old_size_variant_id,
    old_color_variant_id,
    old_product_id,
    product_id,
    size_variant_id,
    color_variant_id
  ) => {
    let count = 0;
    if (old_size_variant_id != size_variant_id) count++;
    if (old_color_variant_id != color_variant_id) count++;
    if (old_product_id != product_id) count++;

    console.log(
      old_size_variant_id,
      old_color_variant_id,
      old_product_id,
      product_id,
      size_variant_id,
      color_variant_id,
      count
    );

    return count;
  };

  const duplicateProductCheck = (products) => {
    // check for duplicate object
    const seen = new Set();

    // Ensure products is an array
    const productArray = Array.isArray(products)
      ? products
      : products?.data || products?.items || [];

    for (const product of productArray) {
      if (!product || isEmpty(product)) continue;

      const key = `${product.product_id}_${product.size_variant_id}_${product.color_variant_id}`;

      if (seen.has(key)) {
        // console.log("duplicate found!");
        return false;
      }
      seen.add(key);
    }
    return true;
  };

  const [isLoading, setIsLoading] = useState(false);
  const { initialValues, setInitialValues, validationSchema, onSubmit } =
    useUpdateForm({
      initialValues: {
        id: null,
        customer_id: null,
        address_id: null,
        sales_channel_id: null,
        delivery_fee: 0,
        note_order: "",
        courier_package: "",
        is_endorsement: false,
        discount_transaction: 0,
        items: [
          {
            id: null,
            product_id: null,
            size_variant_id: null,
            color_variant_id: null,
            qty: 1,
            old_qty: 1,
            unit_price: 0,
            discount_reseller: 0,
            weight: 0,
            old_product_id: null,
            old_color_variant_id: null,
            old_size_variant_id: null,
            status_packing: false,
            notes: "",
          },
        ],
        order_code: "",
      },
      validationSchema: Yup.object().shape({
        customer_id: Yup.number().required("Customer harus diisi"),
        address_id: Yup.number().required("Alamat harus diisi"),
        sales_channel_id: Yup.number().required("Sales Channel harus diisi"),
        delivery_fee: Yup.number(),
        note_order: Yup.string(),
        items: Yup.array()
          .of(
            Yup.object().shape({
              product_id: Yup.number().required("Produk harus diisi"),
              size_variant_id: Yup.number().required("Size harus diisi"),
              color_variant_id: Yup.number().required("Warna harus diisi"),
              qty: Yup.number().required("Qty harus diisi").min(1, "minimal 1"),
              unit_price: Yup.number().required("Harga harus diisi"),
              discount_reseller: Yup.number()
                .min(0, "Diskon 0-" + process.env.REACT_APP_MAX_DISCOUNT)
                .max(
                  Number(process.env.REACT_APP_MAX_DISCOUNT),
                  "Diskon 0-" + process.env.REACT_APP_MAX_DISCOUNT
                ),
            })
          )
          .min(1, "Minimal harus ada 1 Item yang dibeli.")
          .test(
            "Unique",
            "Terdapat produk dengan varian yang sama. Jika varian sama persis, harap menambah melalui QTY.",
            (values) => {
              return duplicateProductCheck(values);
            }
          ),
      }),
      onSubmit: async (values) => {
        const checkStatusPacking = values.items.filter(
          (i) => i.status_packing == true
        );
        if (checkStatusPacking.length > 0) {
          setPayloads("errorMessage.view", {
            title: "Request Edit Sales Order Error",
            message:
              "Terdapat Product yang sudah di packing, order tidak dapat di ubah.",
          });
          openModal("errorMessage.view");
          isError = true;
          return;
        }
        if (needUpdateDeliveryFee) {
          setPayloads("errorMessage.view", {
            title: "Update Sales Order Error",
            message: "Harap kalkulasi ulang ongkir terlebih dahulu.",
          });
          openModal("errorMessage.view");
          isError = true;
        } else {
          try {
            setIsLoading(true);
            const response = await api.salesOrder.update(
              values.id,
              values.customer_id,
              values.address_id,
              values.sales_channel_id,
              delivery_fee,
              values.note_order,
              values.courier_package,
              values.is_endorsement,
              values.discount_transaction,
              values.items
                .filter((orderDetail) => !isEmpty(orderDetail))
                .map((orderDetail) => ({
                  id:
                    checkNew(
                      orderDetail.old_size_variant_id,
                      orderDetail.old_color_variant_id,
                      orderDetail.old_product_id,
                      orderDetail.product_id,
                      orderDetail.size_variant_id,
                      orderDetail.color_variant_id
                    ) == 0
                      ? orderDetail.id
                      : null,
                  // id: orderDetail.id,
                  product_id: orderDetail.product_id,
                  size_variant_id: orderDetail.size_variant_id,
                  color_variant_id: orderDetail.color_variant_id,
                  qty: orderDetail.qty,
                  old_qty:
                    checkNew(
                      orderDetail.old_size_variant_id,
                      orderDetail.old_color_variant_id,
                      orderDetail.old_product_id,
                      orderDetail.product_id,
                      orderDetail.size_variant_id,
                      orderDetail.color_variant_id
                    ) == 0
                      ? orderDetail.old_qty
                      : null,
                  unit_price: orderDetail.unit_price,
                  discount_reseller: orderDetail.discount_reseller,
                  weight: orderDetail.weight,
                  notes:
                    checkNew(
                      orderDetail.old_size_variant_id,
                      orderDetail.old_color_variant_id,
                      orderDetail.old_product_id,
                      orderDetail.product_id,
                      orderDetail.size_variant_id,
                      orderDetail.color_variant_id
                    ) == 0
                      ? orderDetail.notes
                      : null,
                }))
            );
            isError = false;
            return response;
          } catch (error) {
            setPayloads("errorMessage.view", {
              title: "Update Sales Order",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Server Error",
            });
            isError = true;
            openModal("errorMessage.view");
            setIsLoading(false);
          }
        }
      },
      onSuccess: () => {
        if (!isError) {
          handleSuccess();
        }
      },
    });

  const [salesOrder, setSalesOrder, loader, fetch] = useFetcher({
    modelName: "salesOrder",
    payload: { id },
  });

  const [expandedNotes, setExpandedNotes] = useState({});

  const { openModal, setPayloads } = useApplicationModals();
  const [currentErrors, setCurrentErrors] = useState([]);

  function runValidations(values) {
    validationSchema
      .validate(values, { abortEarly: false })
      .then((responseData) => {
        console.log("no validation errors");
        console.log(responseData);
        setCurrentErrors([]);
      })
      .catch((err) => {
        console.log(err);
        console.log(err.name); // ValidationError
        console.log(err.errors);
        setCurrentErrors(err.errors);

        setPayloads("errorMessage.view", {
          title: "Ubah Order Error",
          data: err.errors,
        });
        openModal("errorMessage.view");
      });
  }

  const localHelpers = {
    subtotal: (orderItems) => {
      if (orderItems && orderItems.length > 0) {
        let subtotal = orderItems
          .map(
            (orderItem) =>
              Number(orderItem.qty) *
              (Number(orderItem.unit_price) -
                Number(orderItem.discount_reseller))
          )
          .reduce((partialSum, a) => partialSum + a, 0);

        return subtotal;
      }
    },
    totalWeight: (orderItems) => {
      if (orderItems && orderItems.length > 0) {
        let totalWeightOrder = orderItems
          .map((orderItem) => +orderItem.qty * +orderItem.weight)
          .reduce((partialSum, a) => partialSum + a, 0);

        // console.log("Weight before roundup: ", totalWeightOrder);
        // Round up by 1000
        totalWeightOrder = Math.ceil(totalWeightOrder / 1000) * 1000;
        // console.log("Weight after roundup: ", totalWeightOrder);

        return +totalWeightOrder;
      }
    },
  };

  const getAddress = async (customer_id = 1) => {
    try {
      const response = await api.address.index({ customer_id });

      if (response && response.data) {
        let convert = response.data.map((list) => ({
          value: list.id,
          label: `${list.desc}, Prov. ${list.state_name}, Kab/kota ${list.city_name}, Kec. ${list.district_name}, Kel. ${list.sub_district_name}, Kodepos ${list.zipcode}`,
        }));
        setAddress(convert);
      }
    } catch (error) {
      console.log(error);
      setAddress([]);
    }
  };

  function getUniqueData(product, product_id, variant, selected_variant_id) {
    // console.log("product: ", product);
    // console.log("product_id: ", product_id);
    // console.log("variant: ", variant);
    // console.log("selected_variant_id: ", selected_variant_id);

    let uniqueData = {};
    let isDisabled = false;

    product?.ProductVariants?.forEach((item) => {
      if (variant === "color" && selected_variant_id > 0) {
        if (
          product?.ProductVariants?.find(
            (option) =>
              option.size.id === selected_variant_id &&
              option.color.id === item[`${variant}`].id
          ) === undefined
        ) {
          isDisabled = true;
        } else {
          isDisabled = false;
        }
      }
      if (variant === "size" && selected_variant_id > 0) {
        if (
          product?.ProductVariants?.find(
            (option) =>
              option.color.id === selected_variant_id &&
              option.size.id === item[`${variant}`].id
          ) === undefined
        ) {
          isDisabled = true;
        } else {
          isDisabled = false;
        }
      }
      uniqueData[item[`${variant}`].name] = {
        id: item[`${variant}`].id,
        name: item[`${variant}`].name,
        disabled: isDisabled,
      };
    });

    let convertData = Object.entries(uniqueData).map((item) => {
      return {
        value: item[1].id,
        label: item[1].name,
        disabled: item[1].disabled,
      };
    });

    // console.log("convertData: ", convertData);

    return convertData;
  }

  /**
   * Menghasilkan opsi dropdown varian (size / color) dengan fallback label
   * jika varian yang terpilih pada order detail belum terindeks di ProductVariants.
   *
   * @param {Object} product - Objek produk yang dipilih (berisi ProductVariants).
   * @param {number|string} productId - ID produk saat ini.
   * @param {"size"|"color"} variantType - Tipe varian yang akan diambil ("size" atau "color").
   * @param {number|string} dependentVariantId - ID varian pasangan/pendamping (misal: color_variant_id saat mencari size, atau sebaliknya).
   * @param {Object} orderDetail - Objek item baris order saat ini (berisi fallback id dan label nama varian).
   * @returns {Array<{value: number|string, label: string, disabled?: boolean}>} Daftar opsi untuk SelectMolecule dropdown.
   * @sideEffects Tidak ada (pure function).
   */
  function getVariantOptionsWithFallback(
    product,
    productId,
    variantType,
    dependentVariantId,
    orderDetail
  ) {
    const rawOpts = getUniqueData(
      product,
      productId,
      variantType,
      dependentVariantId
    );
    const opts = Array.isArray(rawOpts) ? [...rawOpts] : [];

    if (variantType === "size") {
      if (
        orderDetail?.size_variant_id &&
        !opts.some((opt) => String(opt.value) === String(orderDetail.size_variant_id))
      ) {
        opts.unshift({
          value: orderDetail.size_variant_id,
          label: orderDetail.size_name || "All Size",
        });
      }
    } else if (variantType === "color") {
      if (
        orderDetail?.color_variant_id &&
        !opts.some((opt) => String(opt.value) === String(orderDetail.color_variant_id))
      ) {
        opts.unshift({
          value: orderDetail.color_variant_id,
          label: orderDetail.color_name || "All Color",
        });
      }
    }

    return opts;
  }

  // const getProduct = async () => {
  //   const response = await api.product.index();

  //   if (response && response.data && response.data.length > 0) {
  //     setProductsAll(response.data);
  //   }
  // };

  async function getCustomerAddress(address_id) {
    const response = await api.address.show(address_id);
    return response?.data?.city_id;
  }

  async function getDeliveryFee(address_id, items, type) {
    if (!address_id) {
      setPayloads("errorMessage.view", {
        title: "Get Ongkir Error",
        message:
          "Tidak dapat kalkulasi ongkir jika alamat tidak ditemukan. Harap set alamat dengan benar.",
      });
      isError = true;
      openModal("errorMessage.view");
      return;
    }

    let destination = await getCustomerAddress(address_id);
    let totalWeightOrder = items
      .map((orderItem) => +orderItem.qty * +orderItem.weight)
      .reduce((partialSum, a) => partialSum + a, 0);

    // Round up by 1000
    totalWeightOrder = Math.ceil(totalWeightOrder / 1000) * 1000;

    if (totalWeightOrder <= 0) {
      setPayloads("errorMessage.view", {
        title: "Get Ongkir Error",
        message:
          "Tidak dapat kalkulasi ongkir jika berat produk 0. Harap set berat produk dengan benar.",
      });
      isError = true;
      openModal("errorMessage.view");
      return;
    }

    if (destination && totalWeightOrder > 0) {
      const response = await api.rajaOngkir.domestic(
        destination,
        totalWeightOrder
      );

      if (response && response.data.length > 0) {
        let filtered = response.data[0]?.costs.filter(
          (i) => i.service == type
        )[0];

        if (!filtered) {
          setDeliveryFee(0);
          setNeedUpdateDeliveryFee(true);
          alert("Kurir tidak tersedia");
        } else {
          setDeliveryFee(filtered?.cost[0]?.value);
          setNeedUpdateDeliveryFee(false);
        }
      }
    }
  }

  // useEffect(() => {
  //   getProduct();
  // }, []);

  const [selectedProducts, setSelectedProducts] = useState([]);

  const handleProductSelected = (selectedProduct, key) => {
    // Save selectedProduct into an array of selectedProducts based on index key
    setSelectedProducts((prevSelectedProducts) => {
      const updatedSelectedProducts = [...prevSelectedProducts];
      updatedSelectedProducts[key] = selectedProduct;
      return updatedSelectedProducts;
    });
  };

  useEffect(() => {
    console.log("selectedProducts: ", selectedProducts);
  }, [selectedProducts]);

  useEffect(() => {
    getAddress(salesOrder.customer_id);
    setDeliveryFee(salesOrder.delivery_fee);
    setSelectedCourier(salesOrder.courier_package);
    if (formSalesOrder.current) {
      const setField = formSalesOrder.current;
      setField.setFieldValue("id", salesOrder.id)
      setField.setFieldValue("customer_id", salesOrder.customer_id)
      setField.setFieldValue("address_id", salesOrder.address_id)
      setField.setFieldValue("sales_channel_id", salesOrder.sales_channel_id)
      setField.setFieldValue("note_order", salesOrder.note_order)
      setField.setFieldValue("courier_package", salesOrder.courier_package)
      setField.setFieldValue("is_endorsement", salesOrder.is_endorsement)
      setField.setFieldValue("discount_transaction", salesOrder.discount_transaction)
      setField.setFieldValue("items", salesOrder?.OrderItems?.map((orderItem, index) => ({
        id: orderItem.id,
        size: getUniqueData(
          selectedProducts[index],
          orderItem.product_id,
          "size"
        ),
        color: getUniqueData(
          selectedProducts[index],
          orderItem.product_id,
          "color"
        ),
        size_variant_id: orderItem.size_variant_id,
        color_variant_id: orderItem.color_variant_id,
        size_name: orderItem?.master_size?.name || "All Size",
        color_name: orderItem?.master_color?.name || "All Color",
        product_id: orderItem.product_id,
        imageUrl: orderItem?.master_product?.imageUrl,
        qty: orderItem.qty,
        old_qty: orderItem.old_qty,
        unit_price: orderItem.unit_price,
        discount_reseller: orderItem.discount_reseller,
        notes: orderItem.notes ? orderItem.notes : "",
        weight: orderItem.weight,
        old_product_id: orderItem.product_id,
        old_size_variant_id: orderItem.size_variant_id,
        old_color_variant_id: orderItem.color_variant_id,
        status_packing: orderItem.status_packing,
      })))
      setField.setFieldValue("order_code", salesOrder?.order_code)
    }

    if (salesOrder?.OrderItems?.length > 0) {
      const initialProducts = salesOrder.OrderItems.map((orderItem) => {
        return orderItem?.master_product
          ? {
              ...orderItem.master_product,
              id: orderItem.product_id || orderItem.master_product.id,
            }
          : orderItem;
      });
      setSelectedProducts(initialProducts);

      const notesState = {};
      salesOrder.OrderItems.forEach((_, index) => {
        notesState[index] = true;
      });
      setExpandedNotes((prev) => ({ ...prev, ...notesState }));
    }
  }, [salesOrder]);

  useEffect(() => {
    console.log("field value", formSalesOrder.current?.values);
  }, [formSalesOrder.current?.values]);

  const handleSuccessCustomerChoose = (customer) => {
    if (formSalesOrder.current) {
      formSalesOrder.current.setFieldValue("customer_id", customer?.customer?.id);
      formSalesOrder.current.setFieldValue("customer_name", customer?.customer?.nickName);
      formSalesOrder.current.setFieldValue("address_id", customer?.address?.id);
      formSalesOrder.current.setFieldValue("customer_address", `${customer?.address?.desc}, Prov. ${customer?.address?.state_name}, Kab/kota ${customer?.address?.city_name}, Kec. ${customer?.address?.district_name}, Kel. ${customer?.address?.sub_district_name}, Kodepos ${customer?.address?.zipcode}`);
    }
  };

  /**
   * Menangani penambahan produk ke dalam form pesanan penjualan (Sales Order) pada mode ubah order.
   * Memperbarui kuantitas produk jika varian sudah ada di keranjang secara immutable,
   * atau menambahkan baris item baru ke Formik items.
   *
   * @param {Object} product - Objek data produk terformat { product, variant }.
   * @sideEffects Mengupdate Formik state values.items secara immutable dan menampilkan toast sukses.
   */
  const handleSuccessProductChoose = (product) => {
    if (formSalesOrder.current) {
      const values = formSalesOrder.current?.values;

      const existingItemIndex = values.items?.findIndex(
        (existingItem) =>
          existingItem.product_id === product?.product?.id &&
          existingItem.size_variant_id === product?.variant?.size?.id &&
          existingItem.color_variant_id === product?.variant?.color?.id
      );

      if (existingItemIndex !== -1) {
        // Jika produk sudah ada di keranjang, tambah kuantitas secara immutable
        const updatedItems = [...values.items];
        updatedItems[existingItemIndex] = {
          ...updatedItems[existingItemIndex],
          qty: Number(updatedItems[existingItemIndex].qty || 0) + 1,
        };
        formSalesOrder.current.setFieldValue("items", updatedItems);
        setSelectedProducts((prev) => {
          const updated = [...prev];
          if (!updated[existingItemIndex]) {
            updated[existingItemIndex] = product?.product;
          }
          return updated;
        });
        setExpandedNotes((prev) => ({ ...prev, [existingItemIndex]: true }));
      } else {
        // Jika produk belum ada, tambahkan item baru ke daftar
        const newIndex = values.items.length;
        const newItems = [
          ...values.items,
          {
            product_id: product?.product?.id,
            size_variant_id: product?.variant?.size?.id,
            color_variant_id: product?.variant?.color?.id,
            size_name: product?.variant?.size?.name || "All Size",
            color_name: product?.variant?.color?.name || "All Color",
            qty: 1,
            unit_price: product?.product?.price,
            discount_reseller: 0,
            weight: product?.product?.weight,
            imageUrl: product?.product?.imageUrl || product?.rawVariant?.imageUrl || "",
          },
        ];
        formSalesOrder.current.setFieldValue("items", newItems);
        setSelectedProducts((prev) => {
          const updated = [...prev];
          updated[newIndex] = product?.product;
          return updated;
        });
        setExpandedNotes((prev) => ({ ...prev, [newIndex]: true }));
      }
      showToast("Anda telah menambahkan produk ke dalam keranjang", "success");
    }
  };

  /**
   * Menangani pembacaan barcode hardware global untuk halaman Ubah Sales Order.
   * Melakukan resolusi barcode bertingkat (memori lokal -> API varian -> API unit -> API SKU produk).
   * Menambahkan item ke pesanan jika ditemukan, atau menampilkan pesan toast error merah jika tidak ditemukan.
   * Mencegah perubahan jika pesanan sudah memiliki invoice terkunci.
   *
   * @param {string} scannedBarcode - Nilai barcode yang telah dibersihkan oleh scanner buffer.
   * @returns {Promise<void>}
   * @sideEffects Mengupdate Formik items atau menampilkan pesan error toast jika barcode tidak ada atau order terkunci.
   */
  const handleBarcodeScan = async (scannedBarcode) => {
    if (!scannedBarcode) return;
    if (salesOrder?.invoice_id) {
      showToast("Order sudah memiliki invoice dan tidak dapat diubah", "error");
      return;
    }
    try {
      const resolvedProduct = await resolveProductBarcode(scannedBarcode, productVariants);
      if (resolvedProduct) {
        handleSuccessProductChoose(resolvedProduct);
      } else {
        showToast(`Barcode "${scannedBarcode}" tidak ditemukan!`, "error");
      }
    } catch (err) {
      console.error("[SalesOrder Update] Error scanning barcode:", err);
      showToast(`Gagal memproses barcode "${scannedBarcode}"`, "error");
    }
  };

  useBarcodeScanner(handleBarcodeScan, { info: "Ubah Order" });

  return (
    <MainLayout
      activeSidebarNavigation="sales"
      activeSidebarChild="order"
      breadcrumbItems={breadcrumbItems}
      pageTitle={
        <div className="flex items-center gap-2">
          {initialValues?.order_code}
        </div>
      }
      headingButtons={[
        {
          label: "Pilih Product",
          type: "button",
          onClick: () => {
            if (salesOrder.invoice_id) {
              setPayloads("errorMessage.view", {
                title: "Error",
                message: "Order tidak dapat diubah.",
              });
              openModal("errorMessage.view");
            } else {
              setPayloads("product.choose");
              openModal("product.choose");
            }
          },
        },
        // {
        //   label:
        //     salesOrder.invoice_id != null ? "Request Edit" : "Generate Invoice",
        //   type: "menuButton",
        //   href:
        //     salesOrder.invoice_id != null
        //       ? "/sales_order_edit_request/create/" + salesOrder.id
        //       : "/invoice/create?customer_id=" + salesOrder.customer_id,
        //   items: [
        //     {
        //       label:
        //         salesOrder.invoice_id != null
        //           ? "View Invoice"
        //           : "Generate Invoice",
        //       href:
        //         salesOrder.invoice_id != null
        //           ? "/invoice/detail/" + salesOrder.invoice_id
        //           : "/invoice/create?customer_id=" + salesOrder.customer_id,
        //     },
        //     {
        //       label: "Tambah Order Baru",
        //       href: "/sales_order/create",
        //     },
        //   ],
        // },
        {
          label: salesOrder.invoice_id != null
            ? "View Invoice"
            : "Generate Invoice",
          type: "menuButton",
          href: salesOrder.invoice_id != null
            ? "/invoice/detail/" + salesOrder.invoice_id
            : "/invoice/create?customer_id=" + salesOrder.customer_id,
          items: [
            {
              label:
                salesOrder.invoice_id != null
                  ? "View Invoice"
                  : "Generate Invoice",
              href:
                salesOrder.invoice_id != null
                  ? "/invoice/detail/" + salesOrder.invoice_id
                  : "/invoice/create?customer_id=" + salesOrder.customer_id,
            },
            {
              label: "Tambah Order Baru",
              href: "/sales_order/create",
            },
          ],
        },
        {
          type: "icon",
          icon: "camera",
          title: "Scan Product QR", // This will be shown as a tooltip
          onClick: () => {
            setPayloads("product.scanQrCode");
            openModal("product.scanQrCode");
          },
        },
      ]}
    >
      <AppModals
        items={["errorMessage.view", "customer.choose", "product.choose", "product.scanQrCode"]}
        onSuccess={{
          "errorMessage.view": () => fetch(),
          "customer.choose": handleSuccessCustomerChoose,
          "product.choose": (data) => handleSuccessProductChoose(data),
          "product.scanQrCode": (data) => handleSuccessProductChoose(data),
        }}
      />
      <Formik
        {...{ initialValues, validationSchema, onSubmit }}
        enableReinitialize={true}
        innerRef={formSalesOrder}
      >
        {({
          values,
          errors,
          status,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form
            className={clsx(
              "px-2 overflow-y-auto",
              style["main-content-height"]
            )}
            onSubmit={handleSubmit}
          >
            <FormHeader>
              <div className="h-full">
                <InputLabel>Customer</InputLabel>
                <p className="py-2 px-1">
                  {salesOrder?.MCustomer?.nickName || 
                   [salesOrder?.MCustomer?.firstName, 
                    salesOrder?.MCustomer?.middleName, 
                    salesOrder?.MCustomer?.lastName]
                    .filter(Boolean).join(" ") || '-'}
                </p>
              </div>
              <SelectMolecule testId="sales-order-update-address-id-select"
                label="Alamat Kirim"
                name="address_id"
                options={addresses}
                onChange={(e) => {
                  handleChange(e);
                  setNeedUpdateDeliveryFee(true);
                }}
                onBlur={handleBlur}
                value={values.address_id}
                errorMessage={
                  errors.address_id && touched.address_id && errors.address_id
                }
              />
              <SelectMolecule testId="sales-order-update-sales-channel-id-select"
                label="Channel"
                name="sales_channel_id"
                options={salesChannels?.map((channel) => ({
                  value: channel.id,
                  label: channel.name,
                }))}
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue("sales_channel_id", e.target.value);
                }}
                onBlur={handleBlur}
                value={values.sales_channel_id}
                errorMessage={
                  errors.sales_channel_id && touched.sales_channel_id && errors.sales_channel_id
                }
              />
              <SelectMolecule testId="sales-order-update-courier-package-select"
                label="Kurir"
                name="courier_package"
                options={[
                  {
                    value: "PAXEL",
                    label: "PAXEL",
                  },
                  {
                    value: "EZ",
                    label: "J&T Express",
                  },
                  {
                    value: "JAGOPACK",
                    label: "LION - JAGOPACK",
                  },
                  {
                    value: "REGPACK",
                    label: "LION - REGPACK",
                  },
                  {
                    value: "BIGPACK",
                    label: "LION - BIGPACK",
                  },
                  {
                    value: "BOSSPACK",
                    label: "LION - BOSSPACK",
                  },
                  {
                    value: "CTC",
                    label: "JNE City Courier",
                  },
                  {
                    value: "JTR",
                    label: "JNE Trucking",
                  },
                  {
                    value: "CTCYES",
                    label: "JNE City Courier YES",
                  },
                ]}
                value={values.courier_package}
                onChange={(e) => {
                  handleChange(e);

                  if (e.target.value !== "PAXEL") {
                    getDeliveryFee(
                      values.address_id,
                      values.items,
                      e.target.value
                    );
                  }
                  setSelectedCourier(e.target.value);
                  setNeedUpdateDeliveryFee(true);
                }}
              />
            </FormHeader>
            <div className="py-2 overflow-x-auto">
              <div className="w-full">
                <FieldArray name="items">
                  {(arrayHelpers) => (
                    <div className="">
                      <Table.Wrapper asIndex={false} overflow={false}>
                        <Table.Header>
                          <Table.HeaderRow>
                            <Table.Heading>Product</Table.Heading>
                            <Table.Heading>Size</Table.Heading>
                            <Table.Heading>Warna</Table.Heading>
                            {/* <Table.Heading>Catatan</Table.Heading> */}
                            <Table.Heading>Qty</Table.Heading>
                            <Table.Heading>
                              <p className="text-right">Harga Satuan</p>
                            </Table.Heading>
                            <Table.Heading>
                              <p className="text-right">Diskon</p>
                            </Table.Heading>
                            <Table.Heading>
                              <p className="text-right">Subtotal</p>
                            </Table.Heading>
                            <Table.Heading></Table.Heading>
                          </Table.HeaderRow>
                        </Table.Header>
                        <Table.Body>
                          {values.items?.map((orderDetail, key) => (
                            <>
                              <Table.BodyRow key={key}>
                                <Table.Cell>
                                  <div className="flex gap-2 items-center">
                                    {orderDetail?.imageUrl && (
                                      <ImageWithPreview
                                        size="lg"
                                        src={`${process.env.REACT_APP_AWS_LINK_URL}${orderDetail?.imageUrl}`}
                                      ></ImageWithPreview>
                                    )}
                                    <div className="w-4/5">
                                      <ProductSelectSearchMolecule
                                        hideLabel={true}
                                        name={`items[${key}].product_id`}
                                        selectedProduct={selectedProducts[key]}
                                        onChange={(e) => {
                                          // reset varian size dan color
                                          values.items[
                                            `${key}`
                                          ].color_variant_id = null;
                                          values.items[`${key}`].size_variant_id =
                                            null;

                                          handleChange(e);

                                          // karena produk diganti, harus kalkulasi ongkir ulang
                                          setNeedUpdateDeliveryFee(true);
                                        }}
                                        onBlur={handleBlur}
                                        value={orderDetail.product_id}
                                        errorMessage={
                                          getIn(
                                            errors,
                                            `items[${key}].product_id`
                                          ) &&
                                          getIn(
                                            touched,
                                            `items[${key}].product_id`
                                          ) &&
                                          getIn(
                                            errors,
                                            `items[${key}].product_id`
                                          )
                                        }
                                        absolute={true}
                                        apiSearch={true}
                                        onProductSelected={(selectedProduct) => {
                                          handleProductSelected(
                                            selectedProduct,
                                            key
                                          );
                                          // setFieldValue(
                                          //   `items.${key}.product_id`,
                                          //   selectedProduct?.id
                                          // );
                                          // setFieldValue(
                                          //   `items.${key}.size_variant_id`,
                                          //   selectedProduct?.size_variant_id
                                          // );
                                          // setFieldValue(
                                          //   `items.${key}.color_variant_id`,
                                          //   selectedProduct?.color_variant_id
                                          // );
                                          // setFieldValue(
                                          //   `items.${key}.unit_price`,
                                          //   selectedProduct?.price
                                          // );
                                          // setFieldValue(
                                          //   `items.${key}.weight`,
                                          //   selectedProduct?.weight
                                          // );
                                          // setFieldValue(
                                          //   `items.${key}.imageUrl`,
                                          //   selectedProduct?.imageUrl
                                          // );
                                        }}
                                        searchText={
                                          selectedProducts[key]?.master_product
                                            ?.code
                                        }
                                      />
                                    </div>
                                  </div>
                                </Table.Cell>
                                <Table.Cell className="w-24">
                                  <SelectMolecule testId="sales-order-update-items-size-variant-id-select"
                                    hideLabel={true}
                                    name={`items[${key}].size_variant_id`}
                                    // options={orderDetail.size}
                                    options={getVariantOptionsWithFallback(
                                      selectedProducts[key],
                                      values.items[`${key}`]?.product_id,
                                      "size",
                                      values.items[`${key}`]?.color_variant_id,
                                      orderDetail
                                    )}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                    onBlur={handleBlur}
                                    value={orderDetail.size_variant_id}
                                    errorMessage={
                                      getIn(
                                        errors,
                                        `items[${key}].size_variant_id`
                                      ) &&
                                      getIn(
                                        touched,
                                        `items[${key}].size_variant_id`
                                      ) &&
                                      getIn(
                                        errors,
                                        `items[${key}].size_variant_id`
                                      )
                                    }
                                    absolute={true}
                                  />
                                </Table.Cell>
                                <Table.Cell className="max-w-xs">
                                  <SelectMolecule testId="sales-order-update-items-color-variant-id-select"
                                    hideLabel={true}
                                    name={`items[${key}].color_variant_id`}
                                    // options={orderDetail.color}
                                    options={getVariantOptionsWithFallback(
                                      selectedProducts[key],
                                      values.items[`${key}`]?.product_id,
                                      "color",
                                      values.items[`${key}`]?.size_variant_id,
                                      orderDetail
                                    )}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                    onBlur={handleBlur}
                                    value={orderDetail.color_variant_id}
                                    errorMessage={
                                      getIn(
                                        errors,
                                        `items[${key}].color_variant_id`
                                      ) &&
                                      getIn(
                                        touched,
                                        `items[${key}].color_variant_id`
                                      ) &&
                                      getIn(
                                        errors,
                                        `items[${key}].color_variant_id`
                                      )
                                    }
                                    absolute={true}
                                  />
                                </Table.Cell>
                                {/* <Table.Cell>
                                <InputMolecule testId="sales-order-update-items-notes-input"
                                  hideLabel={true}
                                  type="text"
                                  name={`items[${key}].notes`}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={orderDetail.notes}
                                  errorMessage={
                                    getIn(errors, `items[${key}].notes`) &&
                                    getIn(touched, `items[${key}].notes`) &&
                                    getIn(errors, `items[${key}].notes`)
                                  }
                                />
                              </Table.Cell> */}
                                <Table.Cell className="w-24">
                                  <InputMolecule testId="sales-order-update-items-qty-input"
                                    hideLabel={true}
                                    type="number"
                                    name={`items[${key}].qty`}
                                    onChange={(e) => {
                                      handleChange(e);
                                      setNeedUpdateDeliveryFee(true);
                                    }}
                                    onBlur={handleBlur}
                                    value={orderDetail.qty}
                                    errorMessage={
                                      getIn(errors, `items[${key}].qty`) &&
                                      getIn(touched, `items[${key}].qty`) &&
                                      getIn(errors, `items[${key}].qty`)
                                    }
                                    align="right"
                                  />
                                </Table.Cell>
                                <Table.Cell className="w-48">
                                  <InputMolecule testId="sales-order-update-items-unit-price-input"
                                    hideLabel={true}
                                    type="number"
                                    name={`items[${key}].unit_price`}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={orderDetail.unit_price}
                                    errorMessage={
                                      getIn(errors, `items[${key}].unit_price`) &&
                                      getIn(
                                        touched,
                                        `items[${key}].unit_price`
                                      ) &&
                                      getIn(errors, `items[${key}].unit_price`)
                                    }
                                    disabled={true}
                                    align="right"
                                  />
                                </Table.Cell>
                                <Table.Cell className="w-32">
                                  <InputMolecule testId="sales-order-update-items-discount-reseller-input"
                                    hideLabel={true}
                                    type="text"
                                    name={`items[${key}].discount_reseller`}
                                    onChange={(event) => {
                                      setFieldValue(`items[${key}].discount_reseller`, event.target.value);
                                      values.items[key].discount_reseller = event.target.value;
                                      setFieldValue(`discount_transaction`, values.is_endorsement ? (Number(localHelpers.subtotal(values.items)) + Number(delivery_fee)) : 0);
                                    }}
                                    onBlur={handleBlur}
                                    value={orderDetail.discount_reseller}
                                    errorMessage={
                                      getIn(
                                        errors,
                                        `items[${key}].discount_reseller`
                                      ) &&
                                      getIn(
                                        touched,
                                        `items[${key}].discount_reseller`
                                      ) &&
                                      getIn(
                                        errors,
                                        `items[${key}].discount_reseller`
                                      )
                                    }
                                    align="right"
                                  />
                                </Table.Cell>
                                <Table.Cell>
                                  <div className="text-right">
                                    <Typography.Currency
                                      number={
                                        orderDetail.qty *
                                        (orderDetail.unit_price -
                                          orderDetail.discount_reseller)
                                      }
                                    />
                                  </div>
                                </Table.Cell>
                                <Table.Cell>
                                  <div className="flex items-center gap-2">
                                    <IconButton testId="sales-order-update-trash-button"
                                      icon={TrashIcon}
                                      onClick={(e) => {
                                        const newArrayItems = values.items.filter((_, index) => index !== key);
                                        setFieldValue("items", newArrayItems);

                                        setSelectedProducts(
                                          (prevSelectedProducts) => {
                                            let updatedSelectedProducts = [];
                                            updatedSelectedProducts =
                                              prevSelectedProducts.filter(
                                                (item, index) => index !== key
                                              );
                                            return updatedSelectedProducts;
                                          }
                                        );
                                      }}
                                    />
                                    <IconButton testId="sales-order-update-tampilkan-catatan-button"
                                      icon={expandedNotes[key] ? MinusCircleIcon : PlusIcon}
                                      onClick={() => setExpandedNotes(prev => ({
                                        ...prev,
                                        [key]: !prev[key]
                                      }))}
                                      title={expandedNotes[key] ? "Sembunyikan Catatan" : "Tampilkan Catatan"}
                                      className="text-gray-500 hover:text-blue-500"
                                      data-tip={expandedNotes[key] ? "Sembunyikan Catatan" : "Tampilkan Catatan"}
                                      data-for="note-tooltip"
                                    />
                                  </div>
                                </Table.Cell>
                              </Table.BodyRow>
                              {/* Notes row */}
                              {expandedNotes[key] && (
                                <Table.BodyRow className="bg-gray-50">
                                  <Table.Cell colSpan="100%" className="py-2">
                                    <div className="px-4">
                                      <InputMolecule testId="sales-order-update-items-notes-input"
                                        label="Catatan"
                                        name={`items[${key}].notes`}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={orderDetail.notes || ''}
                                        placeholder="Tulis catatan untuk item ini..."
                                        errorMessage={
                                          getIn(errors, `items[${key}].notes`) &&
                                          getIn(touched, `items[${key}].notes`) &&
                                          getIn(errors, `items[${key}].notes`)
                                        }
                                      />
                                    </div>
                                  </Table.Cell>
                                </Table.BodyRow>
                              )}
                            </>
                          ))}
                        </Table.Body>
                      </Table.Wrapper>
                      {/* <div>
                        <div className="">
                          <DottedOutlineButton testId="sales-order-update-tambah-item-button"
                            type="button"
                            onClick={(e) =>
                              arrayHelpers.push({
                                product_id: null,
                                size_variant_id: null,
                                color_variant_id: null,
                                qty: 1,
                                unitPrice: 0,
                                discount_reseller: 0,
                                weight: 0,
                              })
                            }
                          >
                            Tambah Item
                          </DottedOutlineButton>
                        </div>
                      </div> */}
                    </div>
                  )}
                </FieldArray>
              </div>
            </div>

            <FormSummary>
              <div className="flex-grow w-full md:max-w-lg order-last md:order-first">
                <InputMolecule testId="sales-order-update-note-order-input"
                  label="Catatan"
                  type="text"
                  name="note_order"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.note_order}
                  errorMessage={
                    errors.note_order &&
                    touched.note_order &&
                    errors.note_order
                  }
                />
              </div>
              <div className="h-full grid grid-cols-2 items-center gap-y-1 gap-x-2 text-right">
                <div className="text-xs uppercase text-gray-600 text-right font-light">
                  Subtotal:{" "}
                </div>
                <div className="pr-7">
                  <Typography.Currency
                    number={localHelpers.subtotal(values?.items)}
                  />
                </div>

                <div className="text-xs uppercase text-gray-600 text-right font-light">
                  Ongkir ({" "}
                  {
                    <Typography.Currency
                      number={localHelpers.totalWeight(values?.items)}
                      fontSize="xs"
                    />
                  }{" "}
                  gram) :{" "}
                </div>
                <div className="flex items-center w-full justify-end">
                  {/* <Typography.Currency number={delivery_fee} /> */}
                  <InputMolecule testId="sales-order-update-delivery-fee-input"
                    hideLabel={true}
                    type="text"
                    name={`delivery_fee`}
                    onChange={(e) => {
                      setDeliveryFee(Math.abs(Number(e.target.value)));
                      setNeedUpdateDeliveryFee(false);
                    }}
                    onBlur={handleBlur}
                    value={delivery_fee}
                    errorMessage={
                      getIn(errors, `delivery_fee`) &&
                      getIn(touched, `delivery_fee`) &&
                      getIn(errors, `delivery_fee`)
                    }
                    align="right"
                  />
                  <IconButton testId="sales-order-update-arrow-path-button"
                    icon={ArrowPathIcon}
                    onClick={(e) => {
                      getDeliveryFee(
                        values.address_id,
                        values.items,
                        selectedCourier
                      );
                      // setNeedUpdateDeliveryFee(false);
                    }}
                    disabled={!needUpdateDeliveryFee}
                    color={needUpdateDeliveryFee ? "accent" : "secondary"}
                  />
                </div>
                <div className="flex items-center w-full justify-end">
                <span className="mr-3 text-sm text-gray-700">Endorsment</span>
                  <input data-testid="sales-order-update-checkbox-input"
                    type="checkbox"
                    checked={values.is_endorsement}
                    onChange={(event) => {
                      const isEndorsement = !values.is_endorsement;
                      setFieldValue('is_endorsement', isEndorsement);
                      setFieldValue('discount_transaction', isEndorsement ? (Number(localHelpers.subtotal(values.items)) + Number(delivery_fee)) : 0);
                    }}
                  />
                </div>
                <div className="flex items-center w-full justify-end">
                </div>
                <div className="text-xs uppercase text-gray-600 text-right font-light">
                  Diskon Order
                </div>
                <div className="flex items-center w-full justify-end">
                  <InputMolecule testId="sales-order-update-discount-transaction-input"
                    hideLabel={true}
                    type="number"
                    name={`discount_transaction`}
                    onChange={(e) => {
                      setFieldValue('discount_transaction', Math.abs(Number(e.target.value)));
                    }}
                    onBlur={handleBlur}
                    value={values.discount_transaction}
                    errorMessage={
                      getIn(errors, `discount_transaction`) &&
                      getIn(touched, `discount_transaction`) &&
                      getIn(errors, `discount_transaction`)
                    }
                    align="right"
                  />
                </div>
                <div className="text-xs uppercase text-gray-600 text-right font-bold">
                  Total:{" "}
                </div>
                <div className="pr-7">
                  <Typography.Currency
                    number={
                      +(localHelpers.subtotal(values?.items) +
                      Number(delivery_fee)) -
                      Number(values.discount_transaction)
                    }
                  />
                </div>
              </div>
            </FormSummary>

            {/* <div className="fixed bottom-0 left-0 right-0 sm:absolute sm:left-auto sm:right-4 sm:bottom-4 sm:w-auto z-40 flex justify-end border-t border-gray-100 bg-white sm:bg-transparent p-4 sm:p-0 dark:border-gray-700 dark:bg-gray-800 print:hidden sm:rounded-b-lg sm:border-0 ">
              {salesOrder?.Invoice?.status !== 3 && (
                <Button testId="sales-order-update-ubah-button"
                  onClick={() => runValidations(values)}
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Ubah"}
                </Button>
              )}
            </div> */}
          </form>
        )}
      </Formik>
    </MainLayout>
  );
}

export default UpdateSalesOrderPage;
